import { matchPath } from "react-router";

import { ROUTES } from "~/constants/routing";
import { categoryTabsConfig } from "~/feature/categories/hooks/useCategoryTabs";

export const isDashboardPath = (pathname: string): boolean => {
  if (
    categoryTabsConfig.some(({ path }) =>
      matchPath({ path, end: true }, pathname)
    )
  ) {
    return true;
  }

  return !!matchPath({ path: ROUTES.category.path, end: true }, pathname);
};
